module.exports = __webpack_public_path__ + "static/media/arrowBack.8e13029a.svg";